/* @flow */
import Entity from 'lib/Entity';

export default class TranscriptRequest extends Entity {
  getInclAnnouncements() {
    return this.get('incl_announcements');
  }

  getInclChat() {
    return this.get('incl_chat');
  }

  getRequestorName() {
    return this.get('requestor_name');
  }

  getNote() {
    return this.get('note');
  }
}
